
<div class="video-modal">
  <div class="modal-content">
    <button class="close-modal" (click)="closeVideo()">×</button>
    <div class="modal-header">
      <h5 class="modal-title">Quiz Question</h5>
    </div>
    <div class="modal-body">
      <p>{{list[count]?.question}}</p>
      <input [(ngModel)]="answer1" class="form-control" placeholder="Your answer">
    </div>
    <div class="modal-footer">
      <button class="btn btn-success" (click)="submit()">Submit</button>
     </div>
  </div>
</div>
<!-- <div class="modal-header">
      <h5 class="modal-title">Quiz Question</h5>
    </div>
    <div class="modal-body">
      <p>{{list[count]?.question}}</p>
      <input [(ngModel)]="answer1" class="form-control" placeholder="Your answer">
    </div>
    <div class="modal-footer">
      <button class="btn btn-success" (click)="submit()">Submit</button>
</div> -->